exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-form-item{margin-bottom:12px}\n", ""]);
